import React from 'react';

export default function ({ language }) {
  class DropdownFrequency extends React.Component {
    constructor() {
      super();
      this.state = {
        config: null,
        row: 3,
        rows: [],
        focused: false,
      };
      this.hiddenRef = React.createRef();
      this.addRow = this.addRow.bind(this);
      this.removeRow = this.removeRow.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.setGlobalState = this.setGlobalState.bind(this);
    }

    componentDidMount = () => {
      this.setState({ config: this.props.field.config });
      const updatedRows = [];
      const iterator = this.props.field.config.startOptions || 1;

      for (let i = 0; i < iterator; i++) {
        updatedRows.push({
          key: null,
          value: null,
        });
      }

      this.setState(
        (state) => ({
          ...state,
          rows: updatedRows,
        }),
        () => this.setGlobalState()
      );
    };

    removeRow = (index) => {
      const newRows = this.state.rows.filter((_, i) => i !== index);
      this.hiddenRef.current.focus();
      this.setState(
        (state) => ({
          ...state,
          rows: newRows,
          // focused: true,
        }),
        () => this.setGlobalState()
      );
    };

    addRow = (e) => {
      e.preventDefault();
      if (this.state.rows.length >= this.state.config.maxOptions) {
        return;
      }
      let newRows = this.state.rows;
      newRows.push({ key: null, value: null });

      this.setState((prevState) => ({
        ...prevState,
        rows: newRows,
      }));
    };

    handleChange = (e, index, name) => {
      e.persist();

      let newRows = this.state.rows;
      newRows[index] = {
        ...newRows[index],
        [name]: e.target.value,
      };

      this.setState(
        (prevState) => ({
          ...prevState,
          rows: newRows,
          focused: true,
        }),
        () => this.setGlobalState()
      );
    };

    handleBlur = (e) => {
      const allowedNames = ['add-row', 'remove-row', 'hidden-checkbox'];
      const nextParentName = e.relatedTarget?.parentNode.getAttribute('name');
      const nextName = e.relatedTarget?.getAttribute('name');
      if (nextParentName === this.state.config?.id) return;
      if (allowedNames.includes(nextName)) return;
      this.setState(
        (prevState) => ({
          ...prevState,
          focused: false,
        }),
        () => this.setGlobalState()
      );
    };

    setGlobalState = () => {
      const { options = [] } = this.props.field.config;
      const displayOf = (list, v) => {
        const found = (list || []).find((o) => (o && typeof o === 'object' ? o.value : o) === v);
        return found && typeof found === 'object' ? found.display ?? found.value : v;
      };

      this.props.field.state.rawValue = this.state.rows;
      this.props.field.state.focused = this.state.focused;
      // value_display is built here because getDisplayValue in lead.js cannot resolve
      // a composed "<day>: <time>" string against the option list.
      this.props.field.state.value = this.state.rows
        .map(({ key, value }) => `${key}: ${value}`)
        .join(', ');
      this.props.field.state.value_display = this.state.rows
        .map(
          ({ key, value }) =>
            `${displayOf(options[0]?.options, key)}: ${displayOf(options[1]?.options, value)}`
        )
        .join(', ');
      this.forceUpdate();
      this.props.onUpdate();
    };

    render() {
      return (
        <div className="lz-input-wrapper" onBlur={(e) => this.handleBlur(e)}>
          <div style={{ width: 0, height: 0, overflow: 'hidden' }}>
            <input
              type="checkbox"
              name="hidden-checkbox"
              ref={this.hiddenRef}
              onBlur={(e) => this.handleBlur(e)}
            />
          </div>
          <label>{this.state.config?.label}</label>
          <span className="lz-extratext"></span>
          <div className="lz-ordered-dropdown-list lz-input-error "></div>
          {this.state.rows.map((row, i) => (
            <DropdownRow
              row={row}
              config={this.state.config}
              index={i}
              key={i}
              addRow={this.addRow}
              removeRow={this.removeRow}
              handleChange={this.handleChange}
              total={this.state.rows.length}
            />
          ))}
          {this.props.errors}
          <div className="lz-input-wrapper">
            <button
              disabled={this.state.rows?.length >= this.state.config?.maxOptions}
              className="lz-add-row lz-add-row--dropdown"
              name="add-row"
              onClick={(e) => this.addRow(e)}
              onBlur={(e) => this.handleBlur(e)}
            >
              <i className="fa fa-plus-circle" aria-hidden="true"></i>
              {language.add_more}
            </button>
          </div>
        </div>
      );
    }
  }

  return {
    html: DropdownFrequency,
    validators: [
      function (state) {
        if (state.focused === false) {
          if (missingDay(state.rawValue) && missingTime(state.rawValue)) {
            return language.dropdownBoth;
          } else if (missingDay(state.rawValue)) {
            return language.dropdownDay;
          } else if (missingTime(state.rawValue)) {
            return language.dropdownTime;
          } else {
            return false;
          }
        }
      },
    ],
  };
}

const DropdownRow = ({ row, config, index, removeRow, handleChange, total }) => {
  return (
    <div className="lz-ordered-dropdown-list--item">
      <DropdownCol
        value={row?.key}
        dropdown={config?.options[0]}
        handleChange={handleChange}
        index={index}
        name="key"
        config={config}
      />
      <DropdownCol
        value={row?.value}
        dropdown={config?.options[1]}
        handleChange={handleChange}
        index={index}
        name="value"
        config={config}
      />
      <div className="lz-ordered-dropdown-list--col">
        {total > 1 && (
          <div
            tabIndex="1"
            name="remove-row"
            onClick={() => removeRow(index)}
            className="lz-fluid-remove"
          >
            <div>
              <i className="fa fa-times-circle" aria-hidden="true"></i>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const DropdownCol = ({ dropdown, handleChange, index, name, value, config }) => {
  return (
    <div className="lz-ordered-dropdown-list--col">
      <div className="lz-input" name={config?.id}>
        <div className="lz-chevron">
          <i className="fa fa-chevron-down"></i>
        </div>
        <select
          value={value ?? dropdown.label}
          tabIndex="1"
          onChange={(e) => handleChange(e, index, name)}
          name={name}
        >
          <option value={dropdown.label} disabled>
            {dropdown?.label}
          </option>
          {dropdown?.options.map((option, i) => (
            <option key={i} value={typeof option === 'object' ? option.value : option}>
              {typeof option === 'object' ? option.display : option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const missingDay = (object) => {
  return Object.values(object)
    .map((item) => item.key)
    .includes(null);
};

const missingTime = (object) => {
  return Object.values(object)
    .map((item) => item.value)
    .includes(null);
};
